import { render, staticRenderFns } from "./serviceStationEdit.vue?vue&type=template&id=31bfbd91&"
import script from "./serviceStationEdit.vue?vue&type=script&lang=js&"
export * from "./serviceStationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports